/**
 * Resolves the label used for the regimen / procedure name banner based on
 * facility category.
 *
 * @module singleOrderForExternal/utils/regimenLabel
 */
import { isExceptionFlowForRadiologyOrg } from "../../../enums/organizationTypes";

/**
 * @param category - Healthcare facility `category` of the current worklist
 * @returns `"Procedure Name"` for radiology exception-flow facilities, otherwise `"Regimen Name"`
 */
export const getRegimenLabel = (category?: string | null): string =>
  isExceptionFlowForRadiologyOrg(category) ? "Procedure Name" : "Regimen Name";
